import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageTopTitle from '../../components/shared/PageTopTitle'
import styled from 'styled-components'
import { getDegerlendirmeler } from '../../features/admin3/admin3Slice'
import { yorumDurumOptions } from '../../utils/yorumOnayOptions'
import SingleInputSelectNew from '../../components/shared/SingleInputSelectNew'
import YorumOnaylariContainer from '../../components/adminContainers/YorumOnaylariContainer'

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

      .content{
        gap: 60px;
        margin: 0 30px;
        margin-top: 20px;
        .titles {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        p{
          text-align: center;
          width: 20%;
        }
      }
        .top-container{
          width: 100%;
          display: flex;
          margin: 20px 0;
        }

    }
}
`

const YorumOnaylari = () => {
    const dispatch = useDispatch()
  const {degerlendirmelerList} = useSelector(state => state.admin3) 
    const [page, setPage] = useState(1)

    const [yorumDurum, setYorumDurum] = useState({
      value: 0,
      text: "Onay Bekleyen"
    })
  
    useEffect(() => {
      const obj = {
        page,
        status: yorumDurum.value
      }
      dispatch(getDegerlendirmeler(obj))
    },[page, yorumDurum])


    const titles = ["Yorum yapılan Üye Adı Soyadı / Ünvanı", "Yorum", "Yorum Yapan Üye Telefonu", "Yorum Yapan Üye Adı Soyadı / Ünvanı", "Yorum Onay"]

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Yorum Onayları"} position='sticky'/>
      <div className="content">
        <div className="top-container">
          <SingleInputSelectNew current={yorumDurum} handleChange={setYorumDurum} options={yorumDurumOptions} name={"isGonderilmis"} width={"270px"} placeholder="" />
        </div>
        <div className="titles">
            {titles.map((item) => (
              <p>{item}</p>
            ))}
        </div>

        {degerlendirmelerList?.map((item)=>(
          <YorumOnaylariContainer data={item} />
        ))}
        {/* <Table titles={titles} data={degerlendirmelerList} type={"yorumOnaylama"} eventQuantity={2} errMessage={"İncelenmeyi Bekleyen Herhangi Bir Yorum Yok"}/> */}
        {/* {
          (UETDSList || UETDSList?.length > 0) &&   
          <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage}/>
        } */}
      </div>

    </div>
  </Container>
  )
}

export default YorumOnaylari